import { useDispatch, useSelector } from 'react-redux'
import ConfirmModalV2 from '../../../components/ConfirmModalV2'
import { setConfirmDefaultTipModal } from '../../ActionCreators'
import styles from './VNConfirmDefaultTipModal.module.scss'
import { getConfirmDefaultTipModal } from '../../Selectors'

export const VNConfirmDefaultTipModal = () => {
  const props = useSelector(getConfirmDefaultTipModal)
  const dispatch = useDispatch()

  if (!props.open) {
    return null
  }

  return (
    <ConfirmModalV2
      classNames={{
        dialogContainer: styles.dialogContainer,
      }}
      onButtonOneClick={() => {
        dispatch(setConfirmDefaultTipModal({ open: false }))
        props?.onCancel && props.onCancel()
      }}
      onButtonTwoClick={() => {
        props?.onConfirm && props.onConfirm()
      }}
      headerText={`Confirm ${props?.initialTipPercentage} Suggested Tip`}
      subtext={'Our staff appreciates your generosity'}
      isKiosk={props?.isKiosk || false}
      buttonOneText={'CANCEL'}
      buttonTwoText={'CONFIRM'}
    />
  )
}
